"use strict";

var React = require("react");

var styletron = require("./index");

var _require = require("styletron-react"),
    Provider = _require.Provider,
    DebugEngine = _require.DebugEngine;

var debug = process.env.NODE_ENV === "production" ? void 0 : new DebugEngine(); // eslint-disable-next-line react/prop-types

exports.wrapRootElement = function (_ref, options) {
  var element = _ref.element;
  var enableDebug = options.debug === true || typeof options.debug === "undefined";
  return /*#__PURE__*/React.createElement(Provider, {
    value: styletron(options).instance,
    debug: enableDebug ? debug : undefined,
    debugAfterHydration: enableDebug
  }, element);
};